import 'parsleyjs';
import { bindAndHandleMealCategory } from './../../mealCategory';
import "../i18n/i18n";

// Validation
// ----------------------------------------------

window.Parsley.addValidator('notDefault', {
	requirementType: 'string',
	validateString: function(value, requirement) {
		return value == requirement;
	},
	messages: {
		en: 'This value is required.'
	}
});

$('form').parsley();

// Binding
// ----------------------------------------------

$( '[data-toggle="tooltip"]' ).tooltip();
$( '[data-toggle="popover"]' ).popover();


// Bootstrap
// ----------------------------------------------

$(document).ready(function ()
{
	$.ajaxSetup({headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	}});

    bindAndHandleMealCategory('#meal-category');
});
